import { apiClient } from './client'
import type { DashboardSummary, Request, RequestItem } from './types'
import type { MyPlanningSummary } from '@crm/shared'

interface MyWorkManager {
  // Продажная форма ответа: менеджер, помощник (заявки прикреплённых
  // менеджеров), РОП (свои города), ADMIN и ГД (вся система).
  role: 'MANAGER' | 'ADMIN' | 'GENERAL_DIRECTOR' | 'ROP' | 'ASSISTANT'
  newRequests: Request[]
  inProcurement: Request[]
  overdue: Request[]
  quotationReady: Request[]
}

interface RequestSummary {
  requestId: string
  requestNumber: string
  client: { id: string; name: string; code: string | null } | null
  total: number
  quoted: number
  status: 'pending' | 'partial' | 'done'
}

interface MyWorkProcurement {
  // Закупочная форма ответа: закупщик и РОЗ (позиции своих городов).
  role: 'PROCUREMENT' | 'ROS'
  queueItems: RequestItem[]
  doneItems: RequestItem[]
  requestSummaries: RequestSummary[]
  totalItems: number
  queueCount: number
  doneCount: number
}

export type MyWork = MyWorkManager | MyWorkProcurement

export async function getDashboardSummary(): Promise<DashboardSummary> {
  const res = await apiClient.get<{ success: true; data: DashboardSummary }>('/dashboard/summary')
  return res.data.data
}

export async function getMyWork(): Promise<MyWork> {
  const res = await apiClient.get<{ success: true; data: MyWork }>('/dashboard/my-work')
  return res.data.data
}

// ─── Дашборд помощника (роль ASSISTANT) ──────────────────────────────────────

export interface AssistantManagerCard {
  id: string
  name: string | null
  email: string
  clientsCount: number
  activeTotal: number
  newCount: number
  inProgressCount: number
  readyForQuotationCount: number
  quoteSentCount: number
  overdueCount: number
  burningCount: number
  /** План и факт менеджера за текущий месяц (29.09.2026); null — нет данных. */
  plan: MyPlanningSummary | null
}

export interface AssistantRequestRow {
  id: string
  requestNumber: string | null
  status: string
  deadline: string | null
  clientName: string | null
  clientCode: string | null
  managerId: string
  managerName: string | null
}

export interface AssistantDashboardData {
  managers: AssistantManagerCard[]
  attention: {
    needQuotation: AssistantRequestRow[]
    overdue: AssistantRequestRow[]
    upcoming: AssistantRequestRow[]
  }
}

export async function getAssistantDashboard(): Promise<AssistantDashboardData> {
  const res = await apiClient.get<{ success: true; data: AssistantDashboardData }>(
    '/dashboard/assistant',
  )
  return res.data.data
}
